// @flow
import React, { type Node } from 'react';

type stringOrNumber = string | number;

export type ColProps = {
    /** Extra small screens | <strong><576px</strong> */
    xs?: stringOrNumber,
    /** Small screens | <strong>≥576px</strong> */
    sm?: stringOrNumber,
    /** Medium screens | <strong>≥768px</strong> */
    md?: stringOrNumber,
    /** Large screens | <strong>≥992px</strong> */
    lg?: stringOrNumber,
    /** Extra large screens | <strong>≥1200px</strong> */
    xl?: stringOrNumber,
    /** will be appended to the classes */
    className: string,
    /** what will be rendered inside the col */
    children: Node,
}


/** A structural component for columns. */
export const Col = React.forwardRef((props: ColProps, ref) => {
    /* Why React.forwardRef? Because I need to get a ref to the DOM element and
     * modifying this component is the way to do this. Not crazy about this! Should
     * we just do this by default in all these bs library components??
     */
    const { xs, sm, md, lg, xl, className = '', children, ...domProps } = props;
    const cols = [];

    if (xs) { cols.push(`col-${xs}`); }
    if (sm) { cols.push(`col-sm-${sm}`); }
    if (md) { cols.push(`col-md-${md}`); }
    if (lg) { cols.push(`col-lg-${lg}`); }
    if (xl) { cols.push(`col-xl-${xl}`); }
    if (cols.length === 0) { cols.push('col'); }

    return <div ref={ref} className={`${cols.join(' ')} ${className}`} {...domProps}>{children}</div>;
});

export default Col;
